/* Progressive enhancement: native scrolling and image links work without JS. */
(function () {
  'use strict';
  if (window.sondosReviewsEditorial) return;
  window.sondosReviewsEditorial = true;

  function mount(root) {
    if (root.dataset.reviewsReady) return;
    root.dataset.reviewsReady = 'true';
    var rail = root.querySelector('.srev__rail');
    if (!rail) return;
    var items = Array.from(rail.children);
    var browse = root.querySelector('.srev__browse');
    var prev = root.querySelector('[data-review-prev]');
    var next = root.querySelector('[data-review-next]');
    var count = root.querySelector('[data-review-current]');
    var frame = 0;
    var current = 0;

    function sync() {
      frame = 0;
      var max = Math.max(0, rail.scrollWidth - rail.clientWidth);
      var x = Math.min(max, Math.abs(rail.scrollLeft));
      var box = rail.getBoundingClientRect();
      var edge = box.right - parseFloat(getComputedStyle(rail).paddingInlineStart || 0);
      // All messages share one stable frame. Read the natural child heights,
      // not the frame's own minimum, so resizing or larger text can still fit.
      var contentHeight = Math.ceil(Math.max.apply(null, items.map(function (item) {
        return Math.max(item.querySelector('.srev__page').getBoundingClientRect().height,
          item.querySelector('.srev__copy').getBoundingClientRect().height);
      })));
      // Perf (2026-10-05): every read happens before the height writes below.
      // This used to run after them, so the first sync() on mount laid the page
      // out twice — once for the reads above, again here because the new
      // block-size had just invalidated it. Same value either way: items are
      // `flex: 0 0 100%` of the rail, so its block-size never moves them
      // horizontally.
      if (Date.now() >= gliding) current = items.reduce(function (best, item, i) {
        return Math.abs(item.getBoundingClientRect().right - edge) <
          Math.abs(items[best].getBoundingClientRect().right - edge) ? i : best;
      }, 0);
      if (contentHeight > 0) {
        var height = contentHeight + 4 + 'px';
        var content = contentHeight + 'px';
        if (rail.style.getPropertyValue('--srev-rail-height') !== height) rail.style.setProperty('--srev-rail-height', height);
        if (rail.style.getPropertyValue('--srev-frame-height') !== content) rail.style.setProperty('--srev-frame-height', content);
      }
      if (!browse) return;
      browse.hidden = max < 2;
      prev.disabled = x < 2;
      next.disabled = x >= max - 2;
      var value = x >= max - 2 && max > 2 ? items.length : current + 1;
      if (count.textContent !== String(value)) count.textContent = value;
    }
    function schedule() { if (!frame) frame = requestAnimationFrame(sync); }
    // While an arrow-driven glide is in flight, sync() must not re-derive
    // current from the half-way scroll position, or a second tap would
    // start from the wrong page. The lock clears itself after the glide.
    var gliding = 0;
    function move(step) {
      current = Math.max(0, Math.min(items.length - 1, current + step));
      // Layout-based destination (offsetLeft), so the target is exact even
      // when the rail is still moving from the previous tap.
      var target = items[current].offsetLeft - items[0].offsetLeft;
      var smooth = !(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
      gliding = Date.now() + (smooth ? 700 : 0);
      rail.scrollTo({ left: target, behavior: smooth ? 'smooth' : 'instant' });
      sync();
    }
    if (prev) prev.addEventListener('click', function () { move(-1); });
    if (next) next.addEventListener('click', function () { move(1); });
    rail.addEventListener('scroll', schedule, { passive: true });
    rail.addEventListener('keydown', function (event) {
      if (event.target !== rail) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        move(event.key === 'ArrowLeft' ? 1 : -1);
      }
    });
    var observer;
    // Perf (2026-10-05): with a ResizeObserver there is no synchronous sync() on
    // mount. Mount runs inside the lazy-hydration task, right after the section was
    // inserted, so that first read forced a layout of the whole new section in the
    // same task (~110ms at 4x CPU). The observer's initial notification already
    // schedules the identical sync() for the next frame, on a page that has been laid
    // out. Nothing can be seen in between: measured at 390/768/1440, the rail's
    // natural height before sync() is exactly the height sync() writes (tallest card
    // + 4px), card heights included.
    if ('ResizeObserver' in window) {
      observer = new ResizeObserver(schedule);
      observer.observe(rail);
      items.forEach(function (item) { observer.observe(item); });
    } else {
      window.addEventListener('resize', schedule, { passive: true });
      sync();
    }

    var dialog = root.querySelector('.srev__lightbox');
    var picture = root.querySelector('.srev__lightbox-img');
    var caption = root.querySelector('.srev__lightbox-cap');
    var status = root.querySelector('.srev__lightbox-status');
    var close = root.querySelector('.srev__lightbox-close');
    var previous = null;
    var savedOverflow = '';
    var request = 0;
    if (dialog && typeof dialog.showModal === 'function') {
      root.querySelectorAll('.srev__shot, [data-review-open]').forEach(function (link) {
        link.setAttribute('aria-haspopup', 'dialog');
      });
      root.addEventListener('click', function (event) {
        var link = event.target.closest('.srev__shot, [data-review-open]');
        if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
        var id = link.getAttribute('data-review-open');
        var shot = id ? document.getElementById(id) : link;
        if (!shot || !root.contains(shot)) return;
        event.preventDefault();
        var thumb = shot.querySelector('img');
        var full = shot.getAttribute('data-full');
        var ticket = ++request;
        picture.src = thumb.currentSrc || thumb.src;
        caption.textContent = shot.getAttribute('data-caption') || '';
        status.textContent = 'جارٍ تحميل المحادثة…';
        previous = link;
        savedOverflow = document.body.style.overflow;
        dialog.showModal();
        document.body.style.overflow = 'hidden';
        close.focus({ preventScroll: true });
        var large = new Image();
        large.onload = function () {
          if (ticket !== request || !dialog.open) return;
          picture.src = full;
          status.textContent = '';
        };
        large.onerror = function () {
          if (ticket === request && dialog.open) status.textContent = 'تعذّر تحميل الصورة الكبيرة. أغلقي المحادثة وحاولي مرة ثانية.';
        };
        large.src = full;
      });
      close.addEventListener('click', function () { dialog.close(); });
      // With one focusable control, keep Tab in the viewer instead of browser chrome.
      dialog.addEventListener('keydown', function (event) {
        if (event.key === 'Tab') {
          event.preventDefault();
          close.focus({ preventScroll: true });
        }
      });
      // Only a click outside the actual dialog rectangle is a backdrop click.
      dialog.addEventListener('click', function (event) {
        if (event.target !== dialog) return;
        var rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      dialog.addEventListener('close', function () {
        request++;
        picture.removeAttribute('src');
        status.textContent = '';
        document.body.style.overflow = savedOverflow;
        if (previous && previous.isConnected) previous.focus({ preventScroll: true });
      });
    }
    root.srevCleanup = function () {
      if (dialog && dialog.open) dialog.close();
      if (observer) observer.disconnect();
      window.removeEventListener('resize', schedule);
      if (frame) cancelAnimationFrame(frame);
    };
  }
  function init(scope) {
    if (scope.matches && scope.matches('.srev')) mount(scope);
    scope.querySelectorAll('.srev').forEach(mount);
  }
  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('.srev').forEach(function (root) { if (root.srevCleanup) root.srevCleanup(); });
  });
  document.addEventListener('shopify:block:select', function (event) {
    var item = event.target.closest('.srev__item');
    if (!item) return;
    var rail = item.closest('.srev__rail');
    var edge = rail.getBoundingClientRect().right - parseFloat(getComputedStyle(rail).paddingInlineStart || 0);
    rail.scrollBy({ left: item.getBoundingClientRect().right - edge, behavior: 'instant' });
  });
})();
